import { rem } from 'polished';
import React from 'react';
import styled from 'styled-components';
const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
  margin: 0 ${rem(4)};
`;
const Title = styled.div `
  font-size: ${rem(16)};
  color: ${({ theme }) => theme.textColor};
  opacity: 1;
  font-weight: 500;
`;
const Subtitle = styled.div `
  font-size: ${rem(13)};
  color: ${({ theme }) => theme.color.fadedText};
  margin-top: ${rem(2)};
`;
const Header = ({ children, className, subtitle }) => {
    return (React.createElement(Wrapper, { className: className },
        React.createElement(Title, null, children),
        subtitle && React.createElement(Subtitle, null, subtitle)));
};
export default Header;
